import { PositionDiscardReason } from '../enums/position-discard-reason.enum';

/**
 * Discard reasons that point to a faulty GPS device and therefore count towards a corrupt frame episode.
 * Left out: speedReasonable and staleOrDuplicate (algorithm and network noise), speedThreshold (can be a
 * real vehicle above 120 km/h) and stationaryJump (mobile only, mobile is out of scope).
 */
export const CORRUPT_FRAME_REASONS: ReadonlySet<PositionDiscardReason> = new Set([
    PositionDiscardReason.SATELLITE_COUNT,
    PositionDiscardReason.ORIGIN_POSITION,
    PositionDiscardReason.ALTITUDE,
    PositionDiscardReason.HDOP,
    PositionDiscardReason.MISSING_COORDINATES,
    PositionDiscardReason.FUTURE_DATE,
]);

/** Time without a valid position (ms) before an episode becomes a CORRUPT_FRAME event. */
export const CORRUPT_FRAME_WINDOW_MS = 10 * 60 * 1000;
